import { CircularProgress } from '@material-ui/core';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { DynamicForm } from '../../components/DynamicForm';
import { useForm } from '../../core/useForm';
import { Utils } from '../../core/Utils';

import './HomeForm.css'

export const HomeForm = ()=>{
    let history = useHistory();
    let  param:{codeform:string}  = useParams();
    const {form} = useForm(param.codeform,history,true);

    return <>{
           !form ? 
            <div className="container-home">
                <CircularProgress color="primary" />
            </div>:
            <> 
         
            <DynamicForm  form={form} sendForm={()=>{
                  history.push("/end/"+form.idForm)
                }
              } 
                closeForm={()=>{
                  history.push("/404")
                }}
                />
          <div className="container mt-5">
            <div className="row">
              <div className="col-12">

                 {form.footer ? <footer id="footer" className="footer p-3" dangerouslySetInnerHTML={Utils.innerHTML(form.footer)}></footer> : null  }

              </div>

            </div>
          </div>
               

              
       
             
             </>
            }</>
}